import React from "react";
import { Instagram, Facebook, Youtube } from "lucide-react";

export const SOCIALS = [
  { name: "Instagram", href: "https://www.instagram.com/bellaedifices/", Icon: Instagram },
  { name: "Facebook", href: "https://www.facebook.com/profile.php?id=61583796117900", Icon: Facebook },
  { name: "TikTok", href: "https://www.tiktok.com/@bella.edifices", Icon: TikTokIcon },
  { name: "YouTube", href: "https://www.youtube.com/@BellaEdifices", Icon: Youtube },
];

export function TikTokIcon({ size = 18, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <path d="M16.5 3c.3 2.2 1.6 3.6 3.7 3.9v2.4c-1.3.1-2.5-.2-3.7-.8v5.7c0 3.4-2.4 5.8-5.6 5.8-3 0-5.4-2.2-5.4-5.2 0-3.1 2.5-5.3 5.7-5v2.5c-.4-.1-.8-.2-1.2-.1-1.4.1-2.4 1.1-2.3 2.6.1 1.3 1.1 2.2 2.4 2.1 1.4-.1 2.2-1 2.2-2.6V3h2.2z" />
    </svg>
  );
}

export default SOCIALS;
